import { z } from "zod";
import { AbstractExtractSchema } from "./abstract/abstractExtract.entities";
import { AwIdSchema, AwLaboratoryIdSchema } from "../traits";

export enum ExtractPatientSchemaEnum {
	ExtractPatient = "ExtractPatient"
};

export const ExtractPatientSchema = AbstractExtractSchema
	.merge(AwIdSchema)
	.merge(AwLaboratoryIdSchema)
	.merge(z.object({
		"@id": z.string(),
		id: z.number(),
		first_name: z.string(),
		last_name: z.string(),
		birth_date: z.string(),
		email: z.string(),
		phone: z.string(),
		phone_mobile: z.string(),
		id_secu: z.string(),
		created_at: z.string(),
	}))
	.describe(ExtractPatientSchemaEnum.ExtractPatient);

export type ExtractPatient = z.infer<typeof ExtractPatientSchema>;
